import * as types from '../mutation-types';
import {unionState, toDateTimeString} from '../helpers';

const state = () => ({
	restaurants: [],
});

const actions = {
	fetchAll({commit}) {
		return axios.get('/api/restaurants').then(response => {
			commit(types.STORE_RESTAURANTS, response.data);
		});
	},

	create({commit}, {name, description, type, images}) {
		const formData = new FormData();
		formData.append('name', name);
		formData.append('description', description);
		formData.append('type_id', type);

		for (let image of images)
			formData.append('images[]', image);

		return axios.post('/api/restaurants', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => {
			commit(types.STORE_RESTAURANT, response.data);

			return response.data;
		});
	},

	fetch({commit}, {id}) {
		return axios.get(`/api/restaurants/${id}`).then(response => {
			commit(types.STORE_RESTAURANT, response.data);
			return response.data;
		});
	},

	delete({commit}, {id}) {
		return axios.delete(`/api/restaurants/${id}`).then(() => {
			commit(types.DELETE_RESTAURANT, id);
		});
	},

	restore({commit}, {id}) {
		return axios.patch(`/api/restaurants/${id}`).then(() => {
			commit(types.RESTORE_RESTAURANT, id);
		});
	},

	update({commit}, {id, name, description, type, images}) {
		const formData = new FormData();
		formData.append('name', name);
		formData.append('description', description);
		formData.append('type_id', type);
		formData.append('_method', 'PUT');

		for (let image of images)
			formData.append('images[]', image);
		
		return axios.post(`/api/restaurants/${id}`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => {
			commit(types.STORE_RESTAURANT, response.data);

			return response.data;
		});
	},
};

const mutations = {
	[types.STORE_RESTAURANTS](state, restaurants) {
		state.restaurants = unionState(state.restaurants, restaurants);
	},

	[types.STORE_RESTAURANT](state, type) {
		state.restaurants = unionState(state.restaurants, [type]);
	},

	[types.DELETE_RESTAURANT](state, id) {
		const restaurant = state.restaurants.find(t => t.id === id);
		restaurant.deleted_at = toDateTimeString(new Date());
	},

	[types.RESTORE_RESTAURANT](state, id) {
		const restaurant = state.restaurants.find(t => t.id === id);
		restaurant.deleted_at = null;
	},
};

const getters = {
	getById: state => id => state.restaurants.find(t => t.id === id),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};